import { useEffect, useState } from "react";
import { Tabs, Form, message, Input, DatePicker, Modal } from "antd";
import PropTypes from "prop-types";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import { AddUser } from '../../style';
import { convertCurrency, ExchangeCurrency } from '../../Filters/FilterConditions';
import { BasicFormWrapper } from '../../../styled';
import { setEditCall, setExPoCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'
import { DealUpdate } from '../../../../Api/Services/DealApiService'

const formFields = ["dealProfit", "dealValue", "grossDealValue", "forecastedValue"]
const InlineEditField = { "expected_closure_date": false, "expected_deal_margin": false, "win_probability": false, "revenue_start_date": false, "revenue_end_date": false, "discount_percentage": false, }
const FilterFields = ["expectedDealLength", "winProbability", "forecastedValue", "expectedClosureDate", "revenueStartDate", "revenueEndDate", "grossDealValue", "discountPercentage", "dealValue", "dealProfit"]

export function validatePercentageField(value, decimalPlace = 2) {
    if (value === undefined || value === null || value === '') return null;
    const basicNumberCheck = /^\d+(\.\d*)?$/;
    if (!basicNumberCheck.test(value)) return 'Please enter a valid number';
    const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalPlace}})?$`);
    if (!decimalRegex.test(value)) return `Only up to ${decimalPlace} decimal place${decimalPlace > 1 ? 's' : ''} are allowed`;
    const num = Number(value);
    if (num < 0 || num > 100) return 'Percentage must be between 0 and 100';
    return null;
}

const LeadTabPage = ({ displayData, allFieldStructure, defaultCurrency, customFields, arrayDisplayData, overAllDetails, setTrigger, ApprovalMessage, AutomationMessage, canUpdateDelete, getData, permissions, dataPermissions, setErrorData, setIsModalVisible1 }) => {
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const [dealDiscount, setDealDiscount] = useState()
    const [displayDatas, setDisplayDatas] = useState()
    const [dealValues, setDealValue] = useState(0)
    const [typeAction, setTypeAction] = useState()
    const [winProbability, setWinProbability] = useState()
    // const [totalDeal, setTotalDeal] = useState(0)
    const [editWon, setEditWon] = useState(false)
    const [edit, setEdit] = useState(false)
    const [pipeLineField, setPipeLineField] = useState()
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [inLineFields, setInLineFields] = useState(InlineEditField)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;

    // Watch the computed form fields so the read-only <span> display updates
    // immediately whenever form.setFieldsValue() updates them inside
    // totalCalculation(). Without this, form.getFieldValue() during render
    // would not trigger a re-render for plain <span> children.
    const dealValueWatch = Form.useWatch('dealValue', form);
    const grossDealValueWatch = Form.useWatch('grossDealValue', form);
    const forecastedValueWatch = Form.useWatch('forecastedValue', form);
    const dealProfitWatch = Form.useWatch('dealProfit', form);
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: '',
            productCategory: '',
            productLicenseSellingPriceUnitMonth: '',
            numberOfUnits: '',
            licenseDuration: null,
            total: '',
        },
    ]);
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: '',
            serviceLineId: '',
            serviceLineCost: '',
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: '',
            country: '',
            rolePerDayRate: '',
            startDate: '',
            endDate: '',
            totalValue: '',
        },
    ]);
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const isEqual = (a, b) => {
        if (a === b) return true;
        // if (typeof a !== typeof b) return false;
        if (
            (typeof a === "number" && typeof b === "string") ||
            (typeof a === "string" && typeof b === "number")
        ) {
            return String(a) === String(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }
        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;
            return keysA.every(key => isEqual(a[key], b[key]));
        }
        return false;
    };
    const getChangedFields = (currentStructure, initialStructure) => {
        return currentStructure.filter((currField) => {
            const initField = initialStructure.find((f) => f.fieldId === currField.fieldId);
            if (!initField) return true;
            const currValue = currField.value;
            const initValue = initField.value;
            return !isEqual(currValue, initValue);
        });
    };
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const mapApiResponseToFormValues = (value) => {
        return value.products.map((product) => ({
            addProductId: product.add_product_id,
            productCategory: product.product_category,
            dealProductId: product.deal_product_id,
            productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
            numberOfUnits: product.number_of_units,
            licenseDuration: product.license_duration,
            total: product.total
        }));
    };
    const mapApiResponseToServicesValues = (value) => {
        return value.service.map((service) => ({
            serviceId: service.service_id,
            serviceName: service.service_name,
            serviceLineId: service.service_line_id,
            serviceLineCost: service.service_line_cost,
        }));
    };
    const mapApiResponseToRoleValues = (value) => {
        return value.staffRoles.map((role) => ({
            staffRoleId: role.staff_role_id,
            addStaffRoleId: role.add_staff_role_id,
            roleName: role.roleName,
            country: role.country,
            rolePerDayRate: role.role_per_day_rate,
            startDate: role.start_date,
            endDate: role.end_date,
            totalValue: role.total_value,
        }));
    };
    function totalCalculation() {
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    sum = 1 * dealValues;
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        sum = 1 * dealValues;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        sum = 1 * dealValues;
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                sum = 1 * dealValues;
            }
        }
        if (typeAction === "Staff Augmentation") {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
        }
        if (dealDiscount !== "0" && dealDiscount !== 0 && dealDiscount !== "" && dealDiscount !== null && dealDiscount !== undefined) {
            totalsum = sum * (1 - Number(dealDiscount) / 100)
        }
        else {
            totalsum = sum
        }
        // Use the freshly computed totalsum (not stale `totalDeal` state)
        // so forecastedValue / dealProfit are correct on the same cycle
        // that formDatas/servicesData/roleData changed.
        if (winProbability !== undefined && winProbability !== "") {
            Fvalue = totalsum * (1 * winProbability / 100)
        }
        if (pipeLineField !== "Won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                profit = totalsum * (1 * changeDealMargin / 100)
            }
        }
        if (pipeLineField === "Won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                profit = totalsum * (1 * changeDealMargin2 / 100)
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace),
            grossDealValue: sum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace),
            dealProfit: profit?.toFixed(CurencyDecimalPlace)
        })
        // setTotalDeal(totalsum);
    }
    const onSubmit = async (values) => {
        let hideMessage;
        const currentStructure = await Promise.all(
            allFieldStructure.map(async (field) => {
                let value;
                switch (field.fieldType) {
                    // case 'FileUpload':
                    //     value = normalizeValue(images[field.fieldKey] ?? null);
                    //     break;
                    // case 'MultiFileUpload':
                    //     value = fileLists[field.fieldKey] || [];
                    //     break;
                    case 'Date':
                        value = values[field.fieldKey]
                            ? moment(values[field.fieldKey]).format("YYYY-MM-DD")
                            : null;
                        break;
                    case 'Number':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Percentage':
                        // string → number or null
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? Number(values[field.fieldKey])
                            : null;
                        break;
                    case 'Currency':
                        value = values[field.fieldKey] !== undefined && values[field.fieldKey] !== "" && values[field.fieldKey] !== null
                            ? await convertCurrency(ConvertRate, Number(values[field.fieldKey]))
                            : null;
                        break;
                    case 'Multi-Dropdown':
                        value = values[field.fieldKey] && values[field.fieldKey].length > 0
                            ? values[field.fieldKey].join(",")
                            : null;
                        break;
                    case 'CheckBox':
                        value = values[field.fieldKey] ?? false;
                        break;
                    default:
                        value = normalizeValue(values[field.fieldKey] ?? null);
                        break;
                }
                return { ...field, value };
            })
        );
        const filteredArray1 = currentStructure.filter(item => FilterFields.includes(item.fieldKey));
        const filteredArray2 = allFieldStructure.filter(item => FilterFields.includes(item.fieldKey));
        const changedFields = getChangedFields(filteredArray1, filteredArray2);
        const noDefaultChanges = changedFields.length === 0;
        if (noDefaultChanges) {
            message.success("Deal updated")
            setEditWon(false)
            dispatch(setEditCall(false));
            setInLineFields(InlineEditField)
            return;
        }
        const defaultChanges = {};
        const customFieldValues = [];
        changedFields.forEach((field) => {
            if (field.customFieldType === "Default") {
                defaultChanges[field.fieldKey] = field.value;
            } else {
                const obj = {
                    entityId: field.entityId,
                    fieldId: field.fieldId,
                    value: field.value,
                };
                customFieldValues.push(obj);
            }
        });
        const payload = {
            ...defaultChanges,
        };
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await DealUpdate(payload, displayData?.deals_id)
            if (response.status === 200) {
                hideMessage();
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    // eslint-disable-next-line no-lonely-if
                    if (response.data[0].message === AutomationMessage) {
                        if (displayDatas?.pipelineStageName === "Won") {
                            dispatch(setExPoCall(true));
                            successMessage("Automation rule triggered", response.data[0].message)
                            setTimeout(() => {
                                dispatch(setExPoCall(false));
                            }, 3000);
                        } else {
                            successMessage("Automation rule triggered", response.data[0].message)
                        }
                    }
                    else if (response.data[0].message === ApprovalMessage) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    }
                    else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                        if (displayDatas?.pipelineStageName === "Won") {
                            dispatch(setExPoCall(true));
                            successMessage("Deal Won", "Deal Closed! Congratulations on winning the deal! Time to celebrate your success")
                            setTimeout(() => {
                                dispatch(setExPoCall(false));
                            }, 3000);
                        } else {
                            message.success(
                                <span>
                                    Deal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                        }
                    } else {
                        message.success(
                            <span>
                                Deal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                            </span>
                        );
                    }
                }
                setEditWon(false)
                dispatch(setEditCall(false));
                getData()
                setInLineFields(InlineEditField)
                setTrigger("activity")
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const setDataForDeal = async (value) => {
        if (value !== undefined) {
            const formValues = mapApiResponseToFormValues(value);
            const servicesValues = mapApiResponseToServicesValues(value);
            const roleValues = mapApiResponseToRoleValues(value)
            form.setFieldsValue(overAllDetails);
            // const DealValue = value.dealValue ? await ExchangeCurrency(Number(value.dealValue), ConvertRate) : value.dealValue;
            const GrossDealValue = value.grossDealValue ? await ExchangeCurrency(Number(value.grossDealValue), ConvertRate) : value.grossDealValue;
            const convertedServicesData = await Promise.all(
                servicesValues.map(async (service) => {
                    const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                        ExchangeCurrency(Number(service.serviceLineCost), ConvertRate)
                        : service.serviceLineCost
                    );
                    return {
                        ...service,
                        serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRoleData = await Promise.all(
                roleValues.map(async (role) => {
                    const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                        ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRate)
                        : role.rolePerDayRate);
                    const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
                        ? ExchangeCurrency(Number(role.totalValue), ConvertRate)
                        : role.totalValue);
                    return {
                        ...role,
                        rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedFormDatas = await Promise.all(
                formValues.map(async (product) => {
                    const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                        ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRate)
                        : product.productLicenseSellingPriceUnitMonth);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRate)
                        : product.total);
                    return {
                        ...product,
                        productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            setPipeLineField(value.pipelineStageName)
            setTypeAction(value.subTypeName)
            setDealValue(Number(GrossDealValue?.toFixed(CurencyDecimalPlace)))
            // setTotalDeal(Number(DealValue?.toFixed(CurencyDecimalPlace)))
            setWinProbability(value.winProbability)
            setDealDiscount(value.discountPercentage)
            setRoleData(convertedRoleData)
            setServiceData(convertedServicesData)
            setFormDatas(convertedFormDatas)
            setChangeDealMargin(value.expectedDealLength)
            setChangeDealMargin2(value.actualDealMargin !== undefined && value.actualDealMargin !== null && value.actualDealMargin !== "" ? value.actualDealMargin : value.expectedDealLength)
            const updatedPerson = {
                ...value,
            };
            setDisplayDatas(updatedPerson)
        }
    }
    useEffect(() => {
        if (displayData) {
            setDataForDeal(displayData)
        }
    }, [displayData])
    useEffect(() => {
        if (displayDatas) {
            if (Role !== "Administrator") {
                if (displayDatas?.pipelineStageName === "Won" || displayDatas?.pipelineStageName === "Lost") {
                    setEditWon(true)
                }
                else {
                    setEdit(true)
                }
            }
            else {
                setEdit(true)
            }
        }
    }, [displayDatas])
    useEffect(() => {
        totalCalculation()
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, changeDealMargin, changeDealMargin2])
    const handleEditFieldChange = (field) => {
        setInLineFields((prevValues) => ({
            ...prevValues,
            [field]: !prevValues[field],
        }));
    };
    const allAttributes = Object.values(customFields).flat();
    const watchedFormFieldValues = {
        dealValue: dealValueWatch,
        grossDealValue: grossDealValueWatch,
        forecastedValue: forecastedValueWatch,
        dealProfit: dealProfitWatch,
    };
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="1">
                                    {arrayDisplayData
                                        ?.filter(group => group.fields?.length > 0)
                                        .map((group, index) => (
                                            <TabPane
                                                tab={group.label || `Group ${index + 1}`}
                                                key={index + 1}
                                            >
                                                {group.fields.map((field) => {
                                                    if (field.fieldKey === "expectedDealLength") {
                                                        return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div style={{ flex: 1 }}>
                                                                <Form.Item key={field.fieldId}
                                                                    label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                    name={field.fieldKey} className="custom-form-item" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validatePercentageField(
                                                                                    value,
                                                                                    CurencyDecimalPlace
                                                                                );

                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }

                                                                                return Promise.resolve();
                                                                            }
                                                                        }
                                                                    ]}>
                                                                    {inLineFields.expected_deal_margin ?
                                                                        <Input prefix="%" min={0} max={100}
                                                                            onBlur={(e) => {
                                                                                if (e.target.value === '' || e.target.value === undefined || e.target.value === null) {
                                                                                    form.setFieldsValue({ [field.fieldKey]: 0 });
                                                                                    setChangeDealMargin(0);
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                const inputValue = e.target.value;
                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                if (!basicNumberCheck) {
                                                                                    return;
                                                                                }
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                    return;
                                                                                }
                                                                                const num = Number(inputValue);
                                                                                if (num < 0 || num > 100) return;
                                                                                setChangeDealMargin(inputValue)
                                                                            }}
                                                                        />
                                                                        : <>
                                                                            {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                                                <div
                                                                                    className={edit ? "edit-span text_icon" : ""}
                                                                                    style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                                >
                                                                                    <span>{field?.value}</span>
                                                                                    {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("expected_deal_margin")} />
                                                                                    }
                                                                                </div>
                                                                                : <span className='text_icon'>
                                                                                    {field?.value}
                                                                                </span>}
                                                                        </>}
                                                                </Form.Item>
                                                            </div>
                                                            {inLineFields.expected_deal_margin ?
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Cancel"
                                                                        onClick={() => {
                                                                            handleEditFieldChange("expected_deal_margin"); getData()
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleEditFieldChange("expected_deal_margin"); getData()
                                                                            }
                                                                        }}
                                                                        aria-label="cancel"
                                                                    >
                                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                    </div>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Save"
                                                                        onClick={() => form.submit()}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                form.submit();
                                                                            }
                                                                        }}
                                                                        aria-label="save"
                                                                    >
                                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                    </div>
                                                                </div> : <></>}
                                                        </div>)
                                                    }
                                                    if (field.fieldKey === "winProbability") {
                                                        return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div style={{ flex: 1 }}> <Form.Item key={field.fieldId}
                                                                label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                name={field.fieldKey} className="custom-form-item"
                                                                rules={displayDatas?.pipelineStageName !== "Won" && displayDatas?.pipelineStageName !== "Prospecting" && displayDatas?.dealTypeName !== "Empanelment" && edit && inLineFields.win_probability ?
                                                                    [{ required: true, message: `Please enter ${field.fieldLabel}`, }, {
                                                                        validator: (_, value) => {
                                                                            const error = validatePercentageField(
                                                                                value,
                                                                                CurencyDecimalPlace
                                                                            );

                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }

                                                                            return Promise.resolve();
                                                                        }
                                                                    }
                                                                    ] : [{ required: false }]}>
                                                                {inLineFields.win_probability ?
                                                                    <Input prefix="%" min={0} max={100}
                                                                        onBlur={(e) => {
                                                                            if (e.target.value === '' || e.target.value === undefined || e.target.value === null) {
                                                                                form.setFieldsValue({ [field.fieldKey]: 0 });
                                                                                setWinProbability(0);
                                                                            }
                                                                        }}
                                                                        onChange={(e) => {
                                                                            const inputValue = e.target.value;
                                                                            const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                            if (!basicNumberCheck) {
                                                                                return;
                                                                            }
                                                                            const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                            if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                return;
                                                                            }
                                                                            const num = Number(inputValue);
                                                                            if (num < 0 || num > 100) return;
                                                                            setWinProbability(inputValue)
                                                                        }} /> :
                                                                    <>
                                                                        {displayDatas?.pipelineStageName !== "Won" && displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                                            <div
                                                                                className={edit ? "edit-span text_icon" : ""}
                                                                                style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                            >
                                                                                <span>{field?.value}</span>
                                                                                {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("win_probability")} />
                                                                                }
                                                                            </div>
                                                                            : <span className='text_icon'>
                                                                                {field?.value}
                                                                            </span>}
                                                                    </>}
                                                            </Form.Item>
                                                            </div>
                                                            {inLineFields.win_probability ?
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Cancel"
                                                                        onClick={() => {
                                                                            handleEditFieldChange("win_probability"); getData()
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleEditFieldChange("win_probability"); getData()
                                                                            }
                                                                        }}
                                                                        aria-label="cancel"
                                                                    >
                                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                    </div>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Save"
                                                                        onClick={() => form.submit()}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                form.submit();
                                                                            }
                                                                        }}
                                                                        aria-label="save"
                                                                    >
                                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                    </div>
                                                                </div> : ""}
                                                        </div>)
                                                    }
                                                    if (field.fieldKey === "expectedClosureDate") {
                                                        return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div style={{ flex: 1 }}><Form.Item key={field.fieldId}
                                                                label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                name={field.fieldKey} className="custom-form-item"
                                                                rules={
                                                                    [{ required: (displayDatas?.pipelineStageName !== "Prospecting" && edit && inLineFields.expected_closure_date), message: `Please enter ${field.fieldLabel}`, },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            const Dependendfield = allAttributes.find((item) => item.fieldKey === "revenueStartDate")
                                                                            const otherValue = form.getFieldValue("revenueStartDate");
                                                                            if (value && otherValue) {
                                                                                if (value > otherValue) {
                                                                                    return Promise.reject(
                                                                                        new Error(`${field.fieldLabel} must be before ${Dependendfield.fieldLabel}`)
                                                                                    );
                                                                                }
                                                                            }
                                                                            return Promise.resolve();
                                                                        }
                                                                    }
                                                                    ]}>
                                                                {inLineFields.expected_closure_date ? <DatePicker
                                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                    disabledDate={(current) => {
                                                                        const start = form.getFieldValue("revenueStartDate");
                                                                        const end = form.getFieldValue("revenueEndDate");
                                                                        return current && (
                                                                            current.isBefore(moment(), "day") ||
                                                                            (start && current.isAfter(start, 'day')) ||
                                                                            (end && current.isAfter(end, 'day'))
                                                                        );
                                                                    }}
                                                                /> : <>
                                                                    {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                                        <div className={edit ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                        >
                                                                            <span>{field?.value}</span>
                                                                            {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("expected_closure_date")} />
                                                                            } </div>
                                                                        : <span className='text_icon'>
                                                                            {field?.value}
                                                                        </span>}
                                                                </>}
                                                            </Form.Item></div>
                                                            {inLineFields.expected_closure_date ?
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Cancel"
                                                                        onClick={() => {
                                                                            handleEditFieldChange("expected_closure_date"); getData()
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleEditFieldChange("expected_closure_date"); getData()
                                                                            }
                                                                        }}
                                                                        aria-label="cancel"
                                                                    >
                                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                    </div>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Save"
                                                                        onClick={() => form.submit()}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                form.submit();
                                                                            }
                                                                        }}
                                                                        aria-label="save"
                                                                    >
                                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                    </div>
                                                                </div> : ""}
                                                        </div>)
                                                    }
                                                    if (field.fieldKey === "revenueStartDate") {
                                                        return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div style={{ flex: 1 }}> <Form.Item key={field.fieldId}
                                                                label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                name={field.fieldKey} className="custom-form-item"
                                                                rules={
                                                                    [{
                                                                        required: (displayDatas?.pipelineStageName !== "Prospecting" &&
                                                                            displayDatas?.dealTypeName !== "Empanelment" &&
                                                                            (edit || editWon) && inLineFields.revenue_start_date), message: `Please enter ${field.fieldLabel}`
                                                                    },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            const closure = form.getFieldValue('expectedClosureDate');
                                                                            const end = form.getFieldValue('revenueEndDate');
                                                                            const closureLabel = allAttributes?.find(item => item.fieldKey === 'expectedClosureDate')?.fieldLabel;
                                                                            const endLabel = allAttributes?.find(item => item.fieldKey === 'revenueEndDate')?.fieldLabel;

                                                                            if (!value) return Promise.resolve();

                                                                            if (closure && value.isBefore(closure, 'day')) {
                                                                                return `${field.fieldLabel} cannot be before ${closureLabel}`
                                                                            }
                                                                            if (end && value.isAfter(end, 'day')) {
                                                                                return `${field.fieldLabel} must be before ${endLabel}`;
                                                                            }
                                                                            return Promise.resolve();
                                                                        }
                                                                    }]}>
                                                                {inLineFields.revenue_start_date ?
                                                                    <DatePicker
                                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                        disabledDate={(current) => {
                                                                            const closure = form.getFieldValue("expectedClosureDate")
                                                                            const end = form.getFieldValue("revenueEndDate");
                                                                            return current && (
                                                                                current.isBefore(moment(), "day") ||
                                                                                (closure && current.isBefore(closure, 'day')) ||
                                                                                (end && current.isAfter(end, 'day'))
                                                                            );
                                                                        }}
                                                                        disabled={typeAction === "Staff Augmentation"}
                                                                    /> :
                                                                    <>
                                                                        {(displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && displayDatas?.subTypeName !== "Staff Augmentation") ?
                                                                            <div className={(edit || editWon) ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                            >
                                                                                <span>
                                                                                    {field?.value}</span>
                                                                                {(edit || editWon) && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("revenue_start_date")} />
                                                                                } </div>
                                                                            : <span className='text_icon'>
                                                                                {field?.value}
                                                                            </span>} </>}
                                                            </Form.Item></div>
                                                            {inLineFields.revenue_start_date ?
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Cancel"
                                                                        onClick={() => {
                                                                            handleEditFieldChange("revenue_start_date"); getData()
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleEditFieldChange("revenue_start_date"); getData()
                                                                            }
                                                                        }}
                                                                        aria-label="cancel"
                                                                    >
                                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                    </div>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Save"
                                                                        onClick={() => form.submit()}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                form.submit();
                                                                            }
                                                                        }}
                                                                        aria-label="save"
                                                                    >
                                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                    </div>
                                                                </div> : ""}
                                                        </div>)
                                                    }
                                                    if (field.fieldKey === "revenueEndDate") {
                                                        return (<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <div style={{ flex: 1 }}><Form.Item key={field.fieldId}
                                                                label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                name={field.fieldKey} className="custom-form-item"
                                                                rules={[{ required: (displayDatas?.pipelineStageName !== "Prospecting" && displayDatas?.dealTypeName !== "Empanelment" && (edit || editWon) && inLineFields.revenue_end_date), message: `Please enter ${field.fieldLabel}` },
                                                                {
                                                                    validator: (_, value) => {
                                                                        const Dependendfield = allAttributes.find((item) => item.fieldKey === "revenueStartDate")
                                                                        const otherValue = form.getFieldValue("revenueStartDate");
                                                                        if (value && otherValue) {
                                                                            if (value < otherValue) {
                                                                                return Promise.reject(
                                                                                    new Error(`${field.fieldLabel} must be after ${Dependendfield.fieldLabel}`)
                                                                                );
                                                                            }
                                                                        }
                                                                        return Promise.resolve();
                                                                    }
                                                                }
                                                                ]}>
                                                                {inLineFields.revenue_end_date ? <DatePicker format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                    disabledDate={(current) => {
                                                                        const start = form.getFieldValue("revenueStartDate");
                                                                        const closure = form.getFieldValue("expectedClosureDate");
                                                                        return (
                                                                            current &&
                                                                            (current.isBefore(moment(), "day") ||
                                                                                (start && current.isBefore(start, "day")) ||
                                                                                (closure && current.isBefore(closure, "day")))
                                                                        );
                                                                    }} disabled={typeAction === "Staff Augmentation"} /> :
                                                                    <>
                                                                        {(displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && displayDatas?.subTypeName !== "Staff Augmentation") ?
                                                                            <div className={(edit || editWon) ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                            >
                                                                                <span>{field?.value}</span>
                                                                                {(edit || editWon) && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("revenue_end_date")} />
                                                                                } </div>
                                                                            : <span className='text_icon'>
                                                                                {field?.value}
                                                                            </span>} </>}
                                                            </Form.Item></div>
                                                            {inLineFields.revenue_end_date ?
                                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Cancel"
                                                                        onClick={() => {
                                                                            handleEditFieldChange("revenue_end_date"); getData()
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                handleEditFieldChange("revenue_end_date"); getData()
                                                                            }
                                                                        }}
                                                                        aria-label="cancel"
                                                                    >
                                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                    </div>
                                                                    <div
                                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        title="Save"
                                                                        onClick={() => form.submit()}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                form.submit();
                                                                            }
                                                                        }}
                                                                        aria-label="save"
                                                                    >
                                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                    </div>
                                                                </div> : ""}
                                                        </div>)
                                                    }
                                                    if (field.fieldKey === "discountPercentage") {
                                                        return (
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                <div style={{ flex: 1 }}><Form.Item key={field.fieldId}
                                                                    label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                                    name={field.fieldKey} className="custom-form-item" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validatePercentageField(
                                                                                    value,
                                                                                    CurencyDecimalPlace
                                                                                );
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            }
                                                                        }
                                                                    ]}>
                                                                    {inLineFields.discount_percentage ?
                                                                        <Input prefix="%" min={0} max={100}
                                                                            onBlur={(e) => {
                                                                                if (e.target.value === '' || e.target.value === undefined || e.target.value === null) {
                                                                                    form.setFieldsValue({ [field.fieldKey]: 0 });
                                                                                    setDealDiscount(0);
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                const inputValue = e.target.value;
                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                if (!basicNumberCheck) {
                                                                                    return;
                                                                                }
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${CurencyDecimalPlace}})?$`);
                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                    return;
                                                                                }
                                                                                const num = Number(inputValue);
                                                                                if (num < 0 || num > 100) return;
                                                                                setDealDiscount(inputValue)
                                                                            }} /> :
                                                                        <>
                                                                            {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                                                <div className={edit ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                                >
                                                                                    <span>{field?.value}</span>
                                                                                    {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("discount_percentage")} />
                                                                                    } </div>
                                                                                : <span className='text_icon'>
                                                                                    {field?.value}
                                                                                </span>}
                                                                        </>}
                                                                </Form.Item></div>
                                                                {inLineFields.discount_percentage ?
                                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                                        <div
                                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            title="Cancel"
                                                                            onClick={() => {
                                                                                handleEditFieldChange("discount_percentage"); getData()
                                                                            }}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    handleEditFieldChange("discount_percentage"); getData()
                                                                                }
                                                                            }}
                                                                            aria-label="cancel"
                                                                        >
                                                                            <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                                        </div>
                                                                        <div
                                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            title="Save"
                                                                            onClick={() => form.submit()}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    form.submit();
                                                                                }
                                                                            }}
                                                                            aria-label="save"
                                                                        >
                                                                            <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                                        </div>
                                                                    </div> : ""}
                                                            </div>)
                                                    }
                                                    const value = formFields.includes(field.fieldKey)
                                                        ? watchedFormFieldValues[field.fieldKey] : null
                                                    return (<Form.Item
                                                        key={field.fieldId}
                                                        label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                        name={field.fieldKey}
                                                        className="custom-form-item"
                                                    >
                                                        <span className="">
                                                            {value ?
                                                                <>{defaultCurrency?.symbol} {Number(value || 0)?.toLocaleString()} </>
                                                                : (field?.value && field?.value !== "") ? field?.value : null}
                                                        </span>
                                                    </Form.Item>
                                                    )
                                                })}
                                            </TabPane>
                                        ))}
                                    <TabPane tab="Other Info" key={(arrayDisplayData?.filter(group => group.fields?.length > 0).length || 0) + 1}>
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayDatas?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} /> : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayDatas?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div>
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    customFields: PropTypes.objectOf(PropTypes.array).isRequired,
    overAllDetails: PropTypes.object.isRequired,
    displayData: PropTypes.object.isRequired,
    defaultCurrency: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    getData: PropTypes.func.isRequired,
    setTrigger: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired,
    dataPermissions: PropTypes.string.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
    arrayDisplayData: PropTypes.array.isRequired,
    allFieldStructure: PropTypes.array.isRequired,
}
export default LeadTabPage;